import { css } from 'styled-components';

const iubendaStyle = css`
  #iubenda-cs-banner {
    bottom: 0px;
    left: 0px;
    position: fixed;
    width: 100%;
    z-index: 99999998;
    background-color: white;
  }

  .iubenda-cs-content {
    display: block;
    margin: 0 auto;
    width: auto;
  }

  .iubenda-cs-rationale {
    @media (min-width: 768px) {
      width: 750px;
    }

    @media (min-width: 992px) {
      width: 970px;
    }

    @media (min-width: 1200px) {
      width: 1170px;
    }

    position: relative;
    margin: 0 auto;
    padding: 20px;
  }

  .iubenda-banner-content {
    padding-right: 20px;
  }

  .iubenda-cs-close-btn {
    margin: 0;
    text-decoration: none;
    font-size: 16px;
    font-weight: bolder;
    color: ${({ theme }) => theme.color.link};
    position: absolute;
    top: 20px;
    right: 20px;
    border: none;
  }

  .iubenda-cs-cookie-policy-lnk {
    color: ${({ theme }) => theme.color.link};
    font-weight: bolder;
    text-decoration: none;
  }
`;

export default iubendaStyle;
